import moment from "moment";
import { getRoundTwo } from "src/helpers/decimal";
import { compareArrayStateStoragePolizaPagar, filterByParams, unificarArrayStateStoragePolizaPagar } from "src/helpers/pagoFedpa";
import { getPolizas } from "src/service/APIService"
import { types } from "../types/types";
import { setAllPolizaAPagar } from "./pago";


export const loadPolizasByIdentificacion = (identificacion, estadoPoliza = null, razonCancelacion = null) => {

    return (dispatch) => {
        dispatch(startLoadingSetPolizas());
        getPolizas()
            .then(
                data => {
                    if (!data.error) {

                        const { data: datos } = data;

                        // compare y validacion de datos
                        const historialArrayPagarCheck = compareArrayStateStoragePolizaPagar(datos);

                        // unficar state y localstorage
                        const unificadoArray = unificarArrayStateStoragePolizaPagar(datos, historialArrayPagarCheck);

                        // formatear datos
                        let formaDatos = unificadoArray.map((value) => ({
                            ...value,
                            CORRIENTE: getRoundTwo(value.CORRIENTE) || 0,
                            CHECK: value.CHECK || false,
                            SALDO: value.SALDO.toFixed(2),
                            PENDIENTE: value.PENDIENTE.toFixed(2),
                            DESCRIPCIONRAMO: `${value.DESCRIPCIONRAMO}`,
                            DESDE: moment(value.DESDE || Date()).format('DD/MM/YYYY'),
                            HASTA: moment(value.HASTA || Date()).format('DD/MM/YYYY'),
                            PAGAR: getRoundTwo(value?.PAGAR) || getRoundTwo(value?.CORRIENTE) || 0
                        }));
                        

                        // Filtrar estado de cancelacion CA y razon de cancelacion 8
                        if (estadoPoliza && razonCancelacion) {

                            const filters = {
                                ESTADOPOLIZA: estadoPoliza,
                                RAZONCANCELACION: razonCancelacion
                            }

                            formaDatos = filterByParams(formaDatos, filters)
                        }


                        dispatch(setPolizas(formaDatos));
                        dispatch(setAllPolizaAPagar(formaDatos));

                    } else {

                    }
                    dispatch(finishLoadingSetPolizas());
                }
            )
    }
}

export const setPolizas = (data) => ({
    type: types.setPoliza,
    payload: data
});


export const startLoadingSetPolizas = () => ({
    type: types.startloadingSetPolizas
});

export const finishLoadingSetPolizas = () => ({
    type: types.finishloadingSetPolizas
});